import { get, post } from '../tools/http';
import Vue from 'vue';

const domain = 'notify';

export default {
    state: () => ({
        notifications: [],
        newNotifications: 0,
    }),
    mutations: {
        setNotifications: (state, items) =>  state.notifications = items,
        addNotification: (state, item) => {
            state.notifications.unshift(item);
        },
        readNotification: (state, i) => 
            Vue.set(state.notifications[i], 'status', 'reed'),
        removeNotification: (state, i) => {
            let items = state.notifications.slice();
            items.splice(i, 1);
            state.notifications = items;
        },
    },
    actions: {
        
        async loadNotifications(ctx) {
            let userId = ctx.rootGetters.user.id;
            let items = await get(domain, `api/v1/notify/user/${userId}`);
            if (items) {
                items = items
                    .sort((a, b) => b.created_at - a.created_at)
                    .map((v) => ({
                        id: v.id,
                        status: v.status,
                        category_color: v.payload.category_color,
                        category_name: v.payload.category_name,
                        link_text: v.payload.link_text,
                        link_url: v.payload.link_url,
                        text: v.payload.text,
                        created_at: v.created_at,
                        is_new: v.status !== 'reed',
                    }));

                ctx.commit('setNotifications', items);
            } else {
                console.log('Error when fetching notifications from server');
            }
        },

        readNotifications: (ctx, items) => {
            console.log(items);
            items.filter(v => v.status !== 'reed')
                .forEach((v) => {
                    ctx.dispatch('readNotification', v.id);
                });
        },
        async readNotification(ctx, notify_id) {
            let index = ctx.state.notifications
                .findIndex((v) => v.id == notify_id);

            if (index > -1) {
                ctx.commit('readNotification', index);
                let res = await post(domain, `api/v1/notify/status/${notify_id}/reed`);
                if (res) {
                    console.log(res);
                    console.log(ctx.state.notifications[index]);
                } else {
                    console.log('Error when read notification');
                }
            }
        },

        async deleteAllNotifications(ctx) {
            for (const item of ctx.state.notifications) {
                await ctx.dispatch('deleteNotification', item.id);
            }
        },
        async deleteNotification(ctx, notify_id) {
            let index = ctx.state.notifications
                .findIndex((v) => v.id == notify_id);

            if (index > -1) {
                ctx.commit('removeNotification', index);
                let res = await post(domain, `api/v1/notify/status/${notify_id}/deleted`);
                if (res) {
                    console.log(res);
                } else {
                    console.log('Error when removing notification');
                }
            }
        },

        onNotificationMessage(ctx, message) {
            ctx.commit('addNotification', {
                id: message.id,
                status: message.status,
                ...message.payload,
                created_at: Date.now() / 1000,
                is_new: true,
            });
        },
    },
    getters: {
        notifications: (state) => state.notifications,
        newNotifications: (state) => state.notifications
            .reduce((count, item) => count + (item.status !== 'reed'), 0), 
    },
};
